import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ children }) {
  const { pathname } = useLocation();
  const [animating, setAnimating] = useState(true);

  useEffect(() => {
    // Force immediate scroll to absolute top of the page on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    // Trigger page entrance animation key
    setAnimating(true);
    const timer = setTimeout(() => {
      setAnimating(false);
    }, 700);

    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <>
      {/* Royal Gold Shimmer Sweep Line at Top of Viewport */}
      {animating && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "4px",
            width: "100%",
            zIndex: 999999,
            background: "linear-gradient(90deg, #FEA116 0%, #D4AF37 50%, #FFF 100%)",
            boxShadow: "0 0 12px rgba(254, 161, 22, 0.8)",
            animation: "hkSweep 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards",
            pointerEvents: "none",
          }}
        />
      )}

      {/* Main Animated Route Wrapper */}
      <div key={pathname} className={`hk-page-entrance-wrapper ${!animating ? "animation-complete" : ""}`}>
        {children}
      </div>

      <style>{`
        @keyframes hkSweep {
          0% {
            transform: translateX(-100%);
            opacity: 1;
          }
          70% {
            opacity: 1;
          }
          100% {
            transform: translateX(0);
            opacity: 0;
          }
        }

        .hk-page-entrance-wrapper {
          animation: hkPageFadeUp 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          will-change: transform, opacity;
        }

        .hk-page-entrance-wrapper.animation-complete {
          animation: none !important;
          transform: none !important;
          will-change: auto !important;
        }

        @keyframes hkPageFadeUp {
          0% {
            opacity: 0.15;
            transform: translateY(18px) scale(0.995);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </>
  );
}
